function key(server: string) {
  const url = new URL(server);
  url.protocol =
    url.protocol === 'wss:' ? 'https:' : url.protocol === 'ws:' ? 'http:' : url.protocol;
  return `rpg-arena-session:${url.origin}`;
}
export function sessionToken(server: string): string {
  try {
    return sessionStorage.getItem(key(server)) ?? '';
  } catch {
    return '';
  }
}
export function saveSessionForServer(server: string, token: string) {
  try {
    if (token) sessionStorage.setItem(key(server), token);
    else sessionStorage.removeItem(key(server));
  } catch {
    /* Private browsing or unconfigured server. */
  }
}
